<!-- Start Navbar Area -->
<div class="navbar-area mobile-nav">
    <div class="evolta-nav">
        <div class="{{ styleContainer }}">
            <nav _ngcontent-ng-c4120282703="" class="navbar navbar-expand-lg navbar-light">
                <a _ngcontent-ng-c4120282703="" class="navbar-brand" ng-reflect-router-link="/" href="#">
                    <img _ngcontent-ng-c4120282703="" src="assets/img/vocbot-logo.png" alt="logo" />
                </a>
                <button _ngcontent-ng-c4120282703="" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler collapsed">
                    <span _ngcontent-ng-c4120282703="" class="navbar-toggler-icon" (click)="toggleMenu()">
                    </span>
                </button>

                <div _ngcontent-ng-c4120282703="" id="navbarSupportedContent" class="navbar-collapse mean-menu collapse"
                    [ngClass]="{ show: isSubMenu }">
                    <ul _ngcontent-ng-c4120282703="" class="navbar-nav">
                        <li _ngcontent-ng-c4120282703="" class="nav-item dropdown">
                            <a _ngcontent-ng-c4120282703="" href="javascript:void(0)" data-bs-toggle="dropdown"
                                class="nav-link dropdown-toggle" [routerLink]="['/home']" routerLinkActive="active" (click)="toggleMenu()">
                                Home
                            </a>
                        </li>

                        <li _ngcontent-ng-c4120282703="" class="nav-item dropdown" routerLinkActive="active">
                            <a _ngcontent-ng-c4120282703="" href="javascript:void(0)"  
                                class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                                About Us
                                <i _ngcontent-ng-c4120282703="" class="fas fa-chevron-down" (click)="openAboutSubMenu()">
                                </i>
                            </a>
 
                            <ul _ngcontent-ng-c4120282703="" class="dropdown-menu" data-bs-popper="static" *ngIf="isAboutubmenu">
                                <li [routerLink]="['/about-us']" _ngcontent-ng-c4120282703="" data-bs-toggle="collapse"
                                    data-bs-target=".navbar-collapse.show" class="nav-item" routerLinkActive="active">
                                    <a _ngcontent-ng-c4120282703="" routerLink="/about-us"  
                                        class="nav-link" (click)="toggleMenu()">
                                        About Us Overview
                                    </a>
                                </li>
                                <li _ngcontent-ng-c4120282703="" data-bs-toggle="collapse"
                                    data-bs-target=".navbar-collapse.show" class="nav-item" routerLinkActive="active">
                                    <a _ngcontent-ng-c4120282703="" routerLink="/why-us"  
                                        class="nav-link" (click)="toggleMenu()">
                                        Why Us? 
                                    </a>
                                </li>
                                 
                            </ul>
                        </li>

                        <li _ngcontent-ng-c4120282703="" class="nav-item dropdown">
                            <a _ngcontent-ng-c4120282703="" href="javascript:void(0)" data-toggle="dropdown"
                                class="nav-link dropdown-toggle" id="navbarDropdown1" aria-haspopup="true" aria-expanded="false">
                                Domain
                                <i _ngcontent-ng-c4120282703="" class="fas fa-chevron-down" (click)="openDomainSubMenu()">
                                </i>
                            </a>

                            <ul _ngcontent-ng-c4120282703="" class="dropdown-menu" aria-labelledby="navbarDropdown1" *ngIf="isDomainSubmenu">
                                <li _ngcontent-ng-c4120282703="" data-bs-toggle="collapse"
                                    data-bs-target=".navbar-collapse.show" class="dropdown-item">
                                    <a routerLink="/education" routerLinkActive="active" (click)="toggleMenu()">
                                        Education
                                    </a>
                                </li>

                                <li _ngcontent-ng-c4120282703="" data-bs-toggle="collapse"
                                    data-bs-target=".navbar-collapse.show" class="dropdown-item">
                                    <a _ngcontent-ng-c4120282703="" routerLink="/healthcare" routerLinkActive="active"
                                        class="nav-link" (click)="toggleMenu()">
                                        Healthcare
                                    </a>
                                </li>

                                <li _ngcontent-ng-c4120282703="" data-bs-toggle="collapse"
                                    data-bs-target=".navbar-collapse.show" class="dropdown-item">
                                    <a _ngcontent-ng-c4120282703="" routerLink="/ecommerce" routerLinkActive="active"
                                        class="nav-link" (click)="toggleMenu()">E-Commerce</a>
                                </li>

                                <li _ngcontent-ng-c4120282703="" data-bs-toggle="collapse"
                                    data-bs-target=".navbar-collapse.show" class="dropdown-item">
                                    <a _ngcontent-ng-c4120282703="" routerLink="/retail" routerLinkActive="active"
                                        class="nav-link" (click)="toggleMenu()">Retail</a>
                                </li>

                                <li _ngcontent-ng-c4120282703="" data-bs-toggle="collapse"
                                    data-bs-target=".navbar-collapse.show" class="dropdown-item">
                                    <a _ngcontent-ng-c4120282703="" routerLink="/tour-and-travels" routerLinkActive="active"
                                        class="nav-link" (click)="toggleMenu()">Tour And Travels</a>
                                </li>

                                <li _ngcontent-ng-c4120282703="" data-bs-toggle="collapse"
                                    data-bs-target=".navbar-collapse.show" class="dropdown-item">
                                    <a _ngcontent-ng-c4120282703="" routerLink="/Utilities" routerLinkActive="active"
                                        class="nav-link" (click)="toggleMenu()">Utilities</a>
                                </li>
                            </ul>
                        </li>

                        <li _ngcontent-ng-c4120282703="" class="nav-item dropdown">
                            <a _ngcontent-ng-c4120282703="" href="javascript:void(0)" data-bs-toggle="dropdown"
                                class="nav-link dropdown-toggle">
                                Services
                                <i _ngcontent-ng-c4120282703="" class="fas fa-chevron-down" (click)="openServiceSubMenu()"></i>
                            </a>

                            <ul _ngcontent-ng-c4120282703="" class="dropdown-menu" data-bs-popper="static">
                                <li _ngcontent-ng-c4120282703="" data-bs-toggle="collapse"
                                    data-bs-target=".navbar-collapse.show" class="nav-item">
                                    <a _ngcontent-ng-c4120282703="" routerLink="/inBound" routerLinkActive="active"
                                        class="nav-link" (click)="toggleMenu()">Inbound Call Center</a>
                                </li>

                                <li _ngcontent-ng-c4120282703="" data-bs-toggle="collapse"
                                    data-bs-target=".navbar-collapse.show" class="nav-item">
                                    <a _ngcontent-ng-c4120282703="" routerLink="/outBound" routerLinkActive="active"
                                        class="nav-link" (click)="toggleMenu()">Outbound Marketing</a>
                                </li>

                                <li _ngcontent-ng-c4120282703="" data-bs-toggle="collapse"
                                    data-bs-target=".navbar-collapse.show" class="nav-item">
                                    <a _ngcontent-ng-c4120282703="" routerLink="/bulkWhatsApp" routerLinkActive="active"
                                        class="nav-link" (click)="toggleMenu()">WhatsApp Sender</a>
                                </li>

                                <li _ngcontent-ng-c4120282703="" data-bs-toggle="collapse"
                                    data-bs-target=".navbar-collapse.show" class="nav-item">
                                    <a _ngcontent-ng-c4120282703="" routerLink="/bulk-sms-sender" routerLinkActive="active"
                                        class="nav-link" (click)="toggleMenu()">Bulk Messenger</a>
                                </li>

                                <li _ngcontent-ng-c4120282703="" data-bs-toggle="collapse"
                                    data-bs-target=".navbar-collapse.show" class="nav-item">
                                    <a _ngcontent-ng-c4120282703="" routerLink="/email" routerLinkActive="active"
                                        class="nav-link" (click)="toggleMenu()">Email</a>
                                </li>

                                <li _ngcontent-ng-c4120282703="" data-bs-toggle="collapse"
                                    data-bs-target=".navbar-collapse.show" class="nav-item">
                                    <a _ngcontent-ng-c4120282703="" routerLink="/whatsapp-meta" routerLinkActive="active"
                                        class="nav-link" (click)="toggleMenu()">Whatsapp Meta</a>
                                </li>

                                <li _ngcontent-ng-c4120282703="" data-bs-toggle="collapse"
                                    data-bs-target=".navbar-collapse.show" class="nav-item">
                                    <a _ngcontent-ng-c4120282703="" routerLink="/rcs" routerLinkActive="active"
                                        class="nav-link" (click)="toggleMenu()">RCS</a>
                                </li>

                                <li _ngcontent-ng-c4120282703="" data-bs-toggle="collapse"
                                    data-bs-target=".navbar-collapse.show" class="nav-item">
                                    <a _ngcontent-ng-c4120282703="" routerLink="/ivr" routerLinkActive="active"
                                        class="nav-link" (click)="toggleMenu()">OBD / IVR</a>
                                </li>
                            </ul>
                        </li>

                        <li _ngcontent-ng-c4120282703="" class="nav-item dropdown">
                            <a routerLink="/plans" _ngcontent-ng-c4120282703="" href="javascript:void(0)"
                                class="nav-link dropdown-toggle" routerLinkActive="active" (click)="toggleMenu()">
                                Plans
                            </a>
                        </li>
                        <li _ngcontent-ng-c4120282703="" class="nav-item dropdown">
                            <a routerLink="/partners" _ngcontent-ng-c4120282703="" href="javascript:void(0)"
                                class="nav-link dropdown-toggle" routerLinkActive="active" (click)="toggleMenu()">
                                Partners
                            </a>
                        </li>

                        <li _ngcontent-ng-c4120282703="" data-bs-toggle="collapse"
                            data-bs-target=".navbar-collapse.show" class="nav-item">
                            <a _ngcontent-ng-c4120282703="" routerLink="/contact" routerLinkActive="active"
                                class="nav-link" (click)="toggleMenu()">Contact</a>
                        </li>

                        <li _ngcontent-ng-c4120282703="" data-bs-toggle="collapse"
                            data-bs-target=".navbar-collapse.show" class="nav-item">
                            <a _ngcontent-ng-c4120282703="" class="nav-link" (click)="openLogin()" target="_blank"
                                routerLinkActive="active" class="nav-link" [href]="loginUrl">Login</a>
                        </li>
                        <li _ngcontent-ng-c4120282703="" data-bs-toggle="collapse"
                            data-bs-target=".navbar-collapse.show" class="nav-item">
                            <a _ngcontent-ng-c4120282703="" [routerLink]="['/book-demo']" class="btns btn-primarys"
                                routerLinkActive="active">
                                Book A Demo
                            </a>
                        </li> 
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</div>

<!-- End Navbar Area -->


<!-- Nav bar for Desktop  -->

<div class="navbar-area desktop-nav">
    <div class="evolta-nav">
        <div class="{{ styleContainer }}">
            <nav class="navbar navbar-expand-lg navbar-light">
                <a class="navbar-brand" ng-reflect-router-link="/" href="#">
                    <img src="assets/img/vocbot-logo.png" alt="logo" />
                </a>
                <button type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler collapsed">
                    <span class="navbar-toggler-icon" (click)="toggleMenu()">
                    </span>
                </button>

                <div id="navbarSupportedContent" class="navbar-collapse mean-menu collapse"
                    [ngClass]="{ show: isSubMenu }">
                    <ul class="navbar-nav">
                        <li class="nav-item dropdown" routerLinkActive="active">
                            <a href="javascript:void(0)" data-bs-toggle="dropdown"
                                class="nav-link dropdown-toggle" [routerLink]="['/home']" (click)="toggleMenu()">
                                Home
                            </a>
                        </li>

                        <li class="nav-item dropdown" routerLinkActive="active">
                            <a href="javascript:void(0)" routerLinkActive="active"
                                class="nav-link dropdown-toggle">
                                About Us
                                <i class="fas fa-chevron-down" (click)="openAboutSubMenu()"></i>
                            </a>

                            <ul class="dropdown-menu" data-bs-popper="static">
                                <li class="nav-item" routerLinkActive="active">
                                    <a routerLink="/about-us" class="nav-link" (click)="toggleMenu();onLinkClick($event,'about-us')">
                                        About Us Overview
                                    </a>
                                </li>
                                <li class="nav-item" routerLinkActive="active">
                                    <a routerLink="/why-us" class="nav-link" (click)="toggleMenu();onLinkClick($event,'why-us')">
                                        Why Us? 
                                    </a>
                                </li>
                            </ul>
                        </li>

                        <li class="nav-item dropdown" routerLinkActive="active">
                            <a href="javascript:void(0)" class="nav-link dropdown-toggle">
                                Domain
                                <i class="fas fa-chevron-down" (click)="openDomainSubMenu()"></i>
                            </a>

                            <ul class="dropdown-menu">
                                <li class="dropdown-item">
                                    <a routerLink="/education" (click)="toggleMenu();onLinkClick($event,'education')">
                                        Education
                                    </a>
                                </li>
                                <li class="dropdown-item">
                                    <a routerLink="/healthcare" (click)="toggleMenu();onLinkClick($event,'healthcare')">
                                        Healthcare
                                    </a>
                                </li>
                                <li class="dropdown-item">
                                    <a [routerLink]="['/ecommerce']" (click)="toggleMenu();onLinkClick($event,'ecommerce')">E-Commerce</a>
                                </li>
                                <li class="dropdown-item">
                                    <a routerLink="/retail" (click)="toggleMenu();onLinkClick($event,'retail')">Retail</a>
                                </li>
                                <li class="dropdown-item">
                                    <a routerLink="/tour-and-travels" (click)="toggleMenu();onLinkClick($event,'tour-and-travels')">Tour And Travels</a>
                                </li>
                                <li class="dropdown-item">
                                    <a routerLink="/Utilities" (click)="toggleMenu();onLinkClick($event,'Utilities')">Utilities</a>
                                </li>
                            </ul>
                        </li>

                        <li class="nav-item dropdown" routerLinkActive="active">
                            <a href="javascript:void(0)" class="nav-link dropdown-toggle">
                                Services
                                <i class="fas fa-chevron-down" (click)="openServiceSubMenu()"></i>
                            </a>

                            <ul class="dropdown-menu">
                                <li class="nav-item" routerLinkActive="active">
                                    <a routerLink="/inBound" class="nav-link" (click)="toggleMenu();onLinkClick($event,'inBound')">Inbound Call Center</a>
                                </li>
                                <li class="nav-item" routerLinkActive="active">
                                    <a routerLink="/outBound" class="nav-link" (click)="toggleMenu();onLinkClick($event,'outBound')">Outbound Marketing</a>
                                </li>
                                <li class="nav-item" routerLinkActive="active">
                                    <a routerLink="/bulkWhatsApp" class="nav-link" (click)="toggleMenu();onLinkClick($event,'bulkWhatsApp')">WhatsApp Sender</a>
                                </li>
                                <li class="nav-item" routerLinkActive="active">
                                    <a routerLink="/bulk-sms-sender" class="nav-link" (click)="toggleMenu();onLinkClick($event,'bulk-sms-sender')">Bulk Messenger</a>
                                </li>
                                <li class="nav-item" routerLinkActive="active">
                                    <a routerLink="/email" class="nav-link" (click)="toggleMenu();onLinkClick($event,'email')">Email</a>
                                </li>
                                <li class="nav-item" routerLinkActive="active">
                                    <a routerLink="/whatsapp-meta" class="nav-link" (click)="toggleMenu();onLinkClick($event,'whatsapp-meta')">Whatsapp Meta</a>
                                </li>
                                <li class="nav-item" routerLinkActive="active">
                                    <a routerLink="/rcs" class="nav-link" (click)="toggleMenu();onLinkClick($event,'rcs')">RCS</a>
                                </li>
                                <li class="nav-item" routerLinkActive="active">
                                    <a routerLink="/ivr" class="nav-link" (click)="toggleMenu();onLinkClick($event,'ivr')">OBD / IVR</a>
                                </li>
                            </ul>
                        </li>

                        <li class="nav-item dropdown" routerLinkActive="active">
                            <a routerLink="/plans" href="javascript:void(0)" class="nav-link dropdown-toggle" (click)="toggleMenu();onLinkClick($event,'plans')">
                                Plans
                            </a>
                        </li>
                        <li class="nav-item dropdown" routerLinkActive="active">
                            <a routerLink="/partners" href="javascript:void(0)" class="nav-link dropdown-toggle" (click)="toggleMenu();onLinkClick($event,'partners')">
                                Partners
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active">
                            <a routerLink="/contact" class="nav-link" (click)="toggleMenu();onLinkClick($event,'contact')">Contact</a>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link" (click)="openLogin()" target="_blank" [href]="loginUrl">Login</a>
                        </li>
                    </ul>

                    <div class="others-options">
                        <a [routerLink]="['/book-demo']" class="btns btn-primarys" (click)="toggleMenu();onLinkClick($event,'book-demo')">
                            Book a Demo
                        </a>
                    </div>
                </div>
            </nav>
        </div>
    </div>
</div>